import { z } from 'zod';
import { apiUrl } from '../config/api';
import { apiClient } from '../lib/apiClient';
import { apiResponseSchema } from '../lib/schemas';

const projectReportSettingSchema = z.object({
  id: z.string(),
  project_id: z.string(),
  include_travel_time: z.boolean(),
  show_isolated_summary: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type ProjectReportSetting = z.infer<typeof projectReportSettingSchema>;

export const projectReportSettingService = {
  async getSetting(projectNumber: string): Promise<ProjectReportSetting> {
    const result = await apiClient.get(apiUrl.projectReportSettings(projectNumber), {
      validate: apiResponseSchema(projectReportSettingSchema),
      deduplicate: true,
      context: 'getProjectReportSetting',
    });
    return result.data;
  },
};
